import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  AccessUserRoleRequest,
  AccessUserRoleResponse,
  AddRolePermissionsRequest,
  AddRolePermissionsResponse,
  AddRoleRequest,
  AddUserRoleRequest,
  AddUserRoleResponse,
  EditRoleRequest,
  GetPermissionsSearchRequest,
  GetPermissionsSearchResponse,
  GetRolePermissionsRequest,
  GetRolesNotExistInUserRolesResponse,
  GetRolesResponse,
  GetUserRolesResponse,
} from "../models/role.model";
import { ApiBaseUrl, Role } from "../config/config";

export const GetUserRoles = async (data: {
  id: number;
}): Promise<GetUserRolesResponse[]> => {
  return await Axios.post<ApiResultModel<GetUserRolesResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/GetUserRoles",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AccessUserRole = async (
  data: AccessUserRoleRequest
): Promise<AccessUserRoleResponse> => {
  return await Axios.post<ApiResultModel<AccessUserRoleResponse>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/AccessUserRole",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetRolesNotExistInUserRoles = async (data: {
  id: number;
}): Promise<GetRolesNotExistInUserRolesResponse[]> => {
  return await Axios.post<
    ApiResultModel<GetRolesNotExistInUserRolesResponse[]>
  >(
    // SERVIES_URL
    ApiBaseUrl + Role + "/GetRolesNotExistInUserRoles",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const AddUserRole = async (
  data: AddUserRoleRequest
): Promise<AddUserRoleResponse[]> => {
  return await Axios.post<ApiResultModel<AddUserRoleResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/AddUserRole",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetRoles = async (): Promise<GetRolesResponse[]> => {
  return await Axios.post<ApiResultModel<GetRolesResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/GetRoles"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPermissionsSearch = async (
  data: GetPermissionsSearchRequest
): Promise<GetPermissionsSearchResponse[]> => {
  return await Axios.post<ApiResultModel<GetPermissionsSearchResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/GetPermissionsSearch",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const AddRole = async (
  data: AddRoleRequest
): Promise<{ id: number }> => {
  return await Axios.post<ApiResultModel<{ id: number }>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/AddRole",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const AddRolePermissions = async (
  data: AddRolePermissionsRequest
): Promise<AddRolePermissionsResponse[]> => {
  return await Axios.post<ApiResultModel<AddRolePermissionsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/AddRolePermissions",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetRolePermissions = async (
  data: GetRolePermissionsRequest
): Promise<AddRolePermissionsResponse[]> => {
  return await Axios.post<ApiResultModel<AddRolePermissionsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/GetRolePermissions",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const DeleteRolePermission = async (data: {
  rolePermissionId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/DeleteRolePermission",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const EditRole = async (data: EditRoleRequest): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/EditRole",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteRole = async (data: { id: number }): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + Role + "/DeleteRole",
    data
  ).then((result) => {
    return result.data.data;
  });
};
